
  import createMeisterIcons from '../src/createMeisterIcons';

  const Pie = createMeisterIcons("pie", [["path",{"fill":"currentColor","d":"M3.75 12a8.25 8.25 0 0 1 16.466-.75H14A2.756 2.756 0 0 0 11.25 14v6.216A8.25 8.25 0 0 1 3.75 12m9 8.216a8.25 8.25 0 0 0 7.466-7.466H14c-.686 0-1.25.564-1.25 1.25zM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25","key":"9e2ca66569e83e49904610ace42e58ee5d218571","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Pie
  